import React from 'react';

import Maps from 'views/Meteorology/Agro/TrackingForecast/Maps';
import DetailedView from 'views/Meteorology/Agro/TrackingForecast/DetailedView';
import TrackingForecast from 'views/Meteorology/Agro/TrackingForecast';

const trackingForecastRouter = {
  path: 'trackingforecast',
  element: <TrackingForecast />,
  children: [
    { path: '', element: <Maps /> },
    { path: 'detailedview', element: <DetailedView /> },
  ],
};

export default trackingForecastRouter;
